import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_warning_circle.svg'
import _imports_1 from '@/app/ui/assets/images/filetype-pdf-default-icon.png'
import _imports_2 from '@/app/ui/assets/svg/trash.svg'


const _hoisted_1 = { class: "flex flex-col p-3 gap-y-3" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "supporting-document-fields" }
const _hoisted_4 = { class: "supporting-document-fields__group" }
const _hoisted_5 = { class: "supporting-document-fields__group" }
const _hoisted_6 = {
  key: 0,
  "data-testid": "booking-v4-supporting-documents-info-copy-duty-tax-terms",
  class: "supporting-document-fields__banner text-xs text-gray-lp-600"
}
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_9 = { class: "supporting-document-panel" }
const _hoisted_10 = {
  "data-testid": "booking-v4-supporting-documents-guide-panel",
  class: "supporting-document-guide"
}
const _hoisted_11 = { class: "flex items-center gap-2 text-xs font-semibold" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4",
  alt: "warning"
}, null, -1)
const _hoisted_13 = { class: "flex items-center gap-2 text-xs text-red-lp-100 font-semibold" }
const _hoisted_14 = {
  key: 0,
  class: "suporting-document-guidline"
}
const _hoisted_15 = { class: "supporting-document-content" }
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-red-lp-1200"
}
const _hoisted_17 = { class: "supporting-document-list" }
const _hoisted_18 = {
  key: 0,
  class: "supporting-document-item"
}
const _hoisted_19 = {
  key: 1,
  class: "supporting-document-item"
}
const _hoisted_20 = {
  key: 2,
  class: "supporting-document-item"
}
const _hoisted_21 = {
  key: 3,
  class: "supporting-document-item"
}
const _hoisted_22 = { class: "additional-document-item__preview" }
const _hoisted_23 = {
  key: 0,
  class: "w-full h-full py-2 px-0.5 flex flex-col items-center"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "image-pdf"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "delete"
}, null, -1)
const _hoisted_26 = { class: "additional-document-item__name" }
const _hoisted_27 = {
  key: 1,
  class: "text-xs text-red-lp-1200"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_Card, {
    rounded: "xl",
    id: "booking-v4-section-supporting-documents",
    "data-testid": "booking-v4-supporting-documents-section"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: _ctx.titleSection,
            fontSize: 16,
            fontColor: "text-color-black-lp-300",
            bold: "bold"
          }, null, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (!_ctx.isHidden('email'))
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  customClass: "w-full",
                  label: _ctx.$t('bookingV4.doc.email.label'),
                  optional: !_ctx.isRequired('email')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      "data-testid": "booking-v4-supporting-documents-input-email",
                      class: "w-full",
                      placeholder: _ctx.$t('bookingV4.doc.email.placeholder'),
                      modelValue: _ctx.activeDoc.email,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeDoc.email = $event)),
                        _ctx.onFieldChange
                      ],
                      maxLength: 100,
                      disabled: _ctx.isDisabled('email'),
                      disableBackground: _ctx.isDisabled('email'),
                      error: !!_ctx.emailError,
                      errorCaption: _ctx.emailError ? _ctx.$t(_ctx.emailError) : '',
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFieldBlur('email')))
                    }, null, 8, ["placeholder", "modelValue", "disabled", "disableBackground", "error", "errorCaption", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "optional"]))
              : _createCommentVNode("", true),
            (!_ctx.isHidden('idNumber'))
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  customClass: "w-full",
                  label: _ctx.$t('bookingV4.doc.idNumber.label'),
                  optional: !_ctx.isRequired('idNumber')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      "data-testid": "booking-v4-supporting-documents-input-nomor-identitas",
                      class: "w-full",
                      placeholder: _ctx.$t('bookingV4.doc.idNumber.placeholder'),
                      modelValue: _ctx.activeDoc.idNumber,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeDoc.idNumber = $event)),
                        _ctx.onFieldChange
                      ],
                      format: _ctx.formatNumberOnly,
                      maxLength: 100,
                      disabled: _ctx.isDisabled('idNumber'),
                      disableBackground: _ctx.isDisabled('idNumber'),
                      error: !!_ctx.idNumberError,
                      errorCaption: _ctx.idNumberError ? _ctx.$t(_ctx.idNumberError) : '',
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFieldBlur('idNumber')))
                    }, null, 8, ["placeholder", "modelValue", "format", "disabled", "disableBackground", "error", "errorCaption", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "optional"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            (!_ctx.isHidden('taxNumber'))
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  customClass: "w-full",
                  label: _ctx.$t('bookingV4.doc.taxNumber.label'),
                  optional: !_ctx.isRequired('taxNumber')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      "data-testid": "booking-v4-supporting-documents-input-nomor-pajak",
                      class: "w-full",
                      placeholder: _ctx.$t('bookingV4.doc.taxNumber.placeholder'),
                      modelValue: _ctx.activeDoc.taxNumber,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeDoc.taxNumber = $event)),
                        _ctx.onFieldChange
                      ],
                      format: _ctx.formatNumberOnly,
                      maxLength: _ctx.isFtz ? 15 : 100,
                      disabled: _ctx.isDisabled('taxNumber'),
                      disableBackground: _ctx.isDisabled('taxNumber'),
                      error: !!_ctx.taxNumberError,
                      errorCaption: _ctx.taxNumberError ? _ctx.$t(_ctx.taxNumberError) : '',
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFieldBlur('taxNumber')))
                    }, null, 8, ["placeholder", "modelValue", "format", "maxLength", "disabled", "disableBackground", "error", "errorCaption", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "optional"]))
              : _createCommentVNode("", true),
            (_ctx.isCipl && !_ctx.isHidden('dutyTaxTerms'))
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  customClass: "w-full",
                  label: _ctx.$t('bookingV4.doc.dutyTaxTerms.label'),
                  tooltipDescription: _ctx.getTranslationText('infoCopy'),
                  isDarkMode: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      id: "booking-v4-supporting-documents-select-duty-tax-terms",
                      "data-testid": "booking-v4-supporting-documents-select-duty-tax-terms",
                      class: "w-full mt-1.5",
                      isDisabled: _ctx.isDisabledDutyTaxTerms,
                      dataSelect: _ctx.dutyTaxTermsOptions,
                      value: _ctx.activeDoc.dutyTaxTerms || '',
                      isOpenMenu: _ctx.isDutyTaxTermsMenuOpen,
                      onOpenSelect: () => _ctx.setDutyTaxTermsMenuOpen(true),
                      onCloseSelect: () => _ctx.setDutyTaxTermsMenuOpen(false),
                      onChooseSelect: _ctx.onDutyTaxTermsChange,
                      isError: !!_ctx.dutyTaxTermsError,
                      errorCaption: _ctx.dutyTaxTermsError ? _ctx.$t(_ctx.dutyTaxTermsError) : ''
                    }, null, 8, ["isDisabled", "dataSelect", "value", "isOpenMenu", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isError", "errorCaption"])
                  ]),
                  _: 1
                }, 8, ["label", "tooltipDescription"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCipl && _ctx.activeDoc.dutyTaxTerms)
            ? (_openBlock(), _createBlock("p", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.getTranslationText(
              _ctx.effectiveDutyTaxTerms === "DAP" ? "recipient" : "shipper"
            )), 1),
                _hoisted_8
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("button", {
              type: "button",
              class: "flex items-center justify-between w-full",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.guidePanelCollapsed = !_ctx.guidePanelCollapsed))
            }, [
              _createVNode("span", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.doc.guide.title")), 1)
              ]),
              _createVNode("span", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.guidePanelCollapsed
                  ? _ctx.$t("bookingV4.doc.guide.expand")
                  : _ctx.$t("bookingV4.doc.guide.collapse")) + " ", 1),
                _createVNode("img", {
                  src: 
                  require(`@/app/ui/assets/svg/${
                    _ctx.guidePanelCollapsed ? 'chevron-down-red' : 'chevron-up-red'
                  }.svg`)
                ,
                  class: "w-4 h-4",
                  alt: "chevron"
                }, null, 8, ["src"])
              ])
            ]),
            (!_ctx.guidePanelCollapsed)
              ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_14, null, 512)), [
                  [_directive_sanitize_html, _ctx.$t('bookingV4.doc.guide.content')]
                ])
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_15, [
            (_ctx.errors.supportingDoc)
              ? (_openBlock(), _createBlock("p", _hoisted_16, _toDisplayString(_ctx.errors.supportingDoc), 1))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_17, [
              (!_ctx.isHidden('imageId'))
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    _createVNode(_component_UploadImageTiny, {
                      key: `${_ctx.documentContextKey}-image-id`,
                      "data-testid": "booking-v4-supporting-documents-upload-ktp",
                      title: _ctx.$t('bookingV4.doc.upload.idCard'),
                      accept: "image/jpg, image/jpeg, image/png, application/pdf",
                      modelValue: _ctx.activeDoc.imageIdUrl,
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeDoc.imageIdUrl = $event)),
                        _cache[9] || (_cache[9] = ($event: any) => (_ctx.onImageChange('imageId')))
                      ],
                      defaultImage: _ctx.activeDoc.imageIdUrl,
                      optional: !_ctx.isRequired('imageId'),
                      maxSize: 5,
                      titleSize: "12",
                      error: !!_ctx.imageErrors.imageId,
                      errorCaption: 
                  _ctx.imageErrors.imageId ? _ctx.$t(_ctx.imageErrors.imageId) : ''
                ,
                      disabled: _ctx.isDisabled('imageId'),
                      onError: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onImageError('imageId'))),
                      onUpload: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onImageUpload('imageId', $event)))
                    }, null, 8, ["title", "modelValue", "defaultImage", "optional", "error", "errorCaption", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isHidden('imageTax'))
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode(_component_UploadImageTiny, {
                      key: `${_ctx.documentContextKey}-image-tax`,
                      "data-testid": "booking-v4-supporting-documents-upload-tax-id",
                      title: _ctx.$t('bookingV4.doc.upload.taxCard'),
                      accept: "image/jpg, image/jpeg, image/png, application/pdf",
                      modelValue: _ctx.activeDoc.imageTaxUrl,
                      "onUpdate:modelValue": [
                        _cache[12] || (_cache[12] = ($event: any) => (_ctx.activeDoc.imageTaxUrl = $event)),
                        _cache[13] || (_cache[13] = ($event: any) => (_ctx.onImageChange('imageTax')))
                      ],
                      defaultImage: _ctx.activeDoc.imageTaxUrl,
                      optional: !_ctx.isRequired('imageTax'),
                      maxSize: 5,
                      titleSize: "12",
                      error: !!_ctx.imageErrors.imageTax,
                      errorCaption: 
                  _ctx.imageErrors.imageTax ? _ctx.$t(_ctx.imageErrors.imageTax) : ''
                ,
                      disabled: _ctx.isDisabled('imageTax'),
                      onError: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onImageError('imageTax'))),
                      onUpload: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onImageUpload('imageTax', $event)))
                    }, null, 8, ["title", "modelValue", "defaultImage", "optional", "error", "errorCaption", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isHidden('imageBeforePacking'))
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _createVNode(_component_UploadImageTiny, {
                      key: `${_ctx.documentContextKey}-image-before-packing`,
                      "data-testid": "booking-v4-supporting-documents-upload-before-packing",
                      title: _ctx.$t('bookingV4.doc.upload.beforePacking'),
                      accept: "image/jpg, image/jpeg, image/png, application/pdf",
                      modelValue: _ctx.activeDoc.imageBeforePackingUrl,
                      "onUpdate:modelValue": [
                        _cache[16] || (_cache[16] = ($event: any) => (_ctx.activeDoc.imageBeforePackingUrl = $event)),
                        _cache[17] || (_cache[17] = ($event: any) => (_ctx.onImageChange('imageBeforePacking')))
                      ],
                      defaultImage: _ctx.activeDoc.imageBeforePackingUrl,
                      optional: !_ctx.isRequired('imageBeforePacking'),
                      maxSize: 5,
                      titleSize: "12",
                      error: !!_ctx.imageErrors.imageBeforePacking,
                      errorCaption: 
                  _ctx.imageErrors.imageBeforePacking
                    ? _ctx.$t(_ctx.imageErrors.imageBeforePacking)
                    : ''
                ,
                      disabled: _ctx.isDisabled('imageBeforePacking'),
                      onError: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onImageError('imageBeforePacking'))),
                      onUpload: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onImageUpload('imageBeforePacking', $event)))
                    }, null, 8, ["title", "modelValue", "defaultImage", "optional", "error", "errorCaption", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isHidden('imageAfterPacking'))
                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                    _createVNode(_component_UploadImageTiny, {
                      key: `${_ctx.documentContextKey}-image-after-packing`,
                      "data-testid": "booking-v4-supporting-documents-upload-after-packing",
                      title: _ctx.$t('bookingV4.doc.upload.afterPacking'),
                      accept: "image/jpg, image/jpeg, image/png, application/pdf",
                      modelValue: _ctx.activeDoc.imageAfterPackingUrl,
                      "onUpdate:modelValue": [
                        _cache[20] || (_cache[20] = ($event: any) => (_ctx.activeDoc.imageAfterPackingUrl = $event)),
                        _cache[21] || (_cache[21] = ($event: any) => (_ctx.onImageChange('imageAfterPacking')))
                      ],
                      defaultImage: _ctx.activeDoc.imageAfterPackingUrl,
                      optional: !_ctx.isRequired('imageAfterPacking'),
                      maxSize: 5,
                      titleSize: "12",
                      error: !!_ctx.imageErrors.imageAfterPacking,
                      errorCaption: 
                  _ctx.imageErrors.imageAfterPacking
                    ? _ctx.$t(_ctx.imageErrors.imageAfterPacking)
                    : ''
                ,
                      disabled: _ctx.isDisabled('imageAfterPacking'),
                      onError: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onImageError('imageAfterPacking'))),
                      onUpload: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onImageUpload('imageAfterPacking', $event)))
                    }, null, 8, ["title", "modelValue", "defaultImage", "optional", "error", "errorCaption", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue.additionalDocuments, (doc, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: doc.id,
                  class: "additional-document-item"
                }, [
                  _createVNode("div", _hoisted_22, [
                    (_ctx.isPdfDocument(doc))
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode("p", {
                            class: "text-center text-black-lp-100 font-medium text-10px mt-auto overflow-ellipsis break-words line-clamp-2",
                            title: _ctx.getAdditionalDocumentFileName(doc, index)
                          }, _toDisplayString(_ctx.getAdditionalDocumentFileName(doc, index)), 9, ["title"]),
                          _createVNode("p", {
                            class: "text-center text-gray-lp-800 text-10px",
                            title: _ctx.getAdditionalDocumentFileSize(doc)
                          }, _toDisplayString(_ctx.getAdditionalDocumentFileSize(doc)), 9, ["title"])
                        ]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          class: "image-preview",
                          src: doc.url,
                          alt: _ctx.getAdditionalDocumentFileName(doc, index)
                        }, null, 8, ["src", "alt"])),
                    (!_ctx.isDisabled('imageAfterPacking'))
                      ? (_openBlock(), _createBlock("button", {
                          key: 2,
                          type: "button",
                          "data-testid": 
                    `booking-v4-supporting-documents-button-remove-other-${doc.id}`
                  ,
                          class: "additional-document-item__remove",
                          onClick: ($event: any) => (_ctx.onRemoveAdditionalDocument(doc.id))
                        }, [
                          _hoisted_25
                        ], 8, ["data-testid", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode("p", _hoisted_26, null, 512), [
                    [_directive_sanitize_html, _ctx.$t('bookingV4.doc.upload.additionalDocument')]
                  ])
                ]))
              }), 128)),
              (
                !_ctx.isDisabled('imageAfterPacking') &&
                  _ctx.modelValue.additionalDocuments.length < _ctx.maxAdditionalDocuments
              )
                ? (_openBlock(), _createBlock("button", {
                    key: 4,
                    type: "button",
                    "data-testid": "booking-v4-supporting-documents-button-add-other",
                    class: "additional-document-add",
                    disabled: _ctx.isDisabled('imageAfterPacking'),
                    "aria-label": _ctx.$t('bookingV4.doc.upload.additional'),
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.triggerAddAdditionalDocument && _ctx.triggerAddAdditionalDocument(...args)))
                  }, [
                    _createVNode(_component_Icons, {
                      name: "plus-circle-outline",
                      class: "w-5 h-5 text-red-lp-2400"
                    })
                  ], 8, ["disabled", "aria-label"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.additionalDocumentError)
              ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(_ctx.$t(_ctx.additionalDocumentError)), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("input", {
            ref: "additionalDocumentInput",
            type: "file",
            class: "hidden",
            accept: "image/jpg, image/jpeg, image/png, application/pdf",
            onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onAdditionalDocumentSelected && _ctx.onAdditionalDocumentSelected(...args)))
          }, null, 544)
        ])
      ])
    ]),
    _: 1
  }))
}